import React, { useEffect, useState } from "react";

import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { Value } from "./value";
import { fetchHcfDetails } from "./api";
import styled from "styled-components";
import { showSuccessToast } from "@src/appV2/lib/Notifications";
import { handleApiError } from "src/utils/errors";

const Container = styled.div`
  margin-bottom: 10px;
`;

function RushCharge({ hcfId, updateFacility }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "rushFee").then(setDetails).catch(setError);
  }, [hcfId]);

  const updateLocal = (data) => {
    // `data` is undefined if saveFacility's retrieveUser refresh failed
    // (swallowed there). The optimistic update already reflects the
    // submitted value, so leave local state alone in that case.
    if (!data?.facility?.rushFee) {
      return;
    }
    setDetails((prev) => ({ ...prev, rushFee: data.facility.rushFee }));
  };

  const handleChange = (data) => {
    const previousRushFee = details?.rushFee;

    setDetails((prev) => ({
      ...prev,
      rushFee: { ...prev?.rushFee, ...data },
    }));

    updateFacility({
      facilityId: hcfId,
      rushFee: data,
    })
      .then(updateLocal)
      .then(() => showSuccessToast("Rush charge has been updated."))
      .catch((error) => {
        handleApiError(error);
        setDetails((prev) => ({ ...prev, rushFee: previousRushFee }));
      });
  };

  return (
    <Container>
      <Title>Shift Rush Charge (added to Worker Base Charge)</Title>
      <ShowError error={error} message="Unable to fetch workplace Late Cancel Charge" />
      <p className="content">
        Shift created within
        <Value name="period" onChange={handleChange} value={details?.rushFee?.period} />
        hrs of shift start will have
        <Value name="differential" onChange={handleChange} value={details?.rushFee?.differential} />
        /hr added to the Workplace Base Charge.
      </p>
    </Container>
  );
}

export { RushCharge };
